import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { Card, BodyText, Box, MaterialSymbol, withStyles } from 'vopay';
import { Button } from 'UI';
import { Dialog } from '@/providers/Dialog.provider';
import styles from './BlockingDialog.module.scss';
import blockSubAccountIcon from './icons/blockSubAccount.svg';

const cn = withStyles(styles);

export type BlockDialogProps = {
  onConfirm: (val: boolean) => void;
  onCancel: () => void;
};

const BlockDialog: FunctionComponent<BlockDialogProps> = ({ onConfirm, onCancel }) => {
  const { t } = useTranslation('translations', { keyPrefix: 'SubAccounts.BlockDialog' });

  return (
    <Card className={cn('dialogueCard')}>
      <div className={cn('icon')}>
        <img src={blockSubAccountIcon} alt="Block Sub-Account" width="80" height="80" />
      </div>

      <div className={cn('title')}>
        <Dialog.Title level="3">{t('title', { defaultValue: 'Block Sub-Accounts' })}</Dialog.Title>
      </div>

      <BodyText className={cn('bodyText')}>
        <div className={cn('description')}>{t('description', { defaultValue: 'Blocking all sub-accounts will:' })}</div>

        <ul className={cn('bulletList')}>
          <li>{t('stopOutbound', { defaultValue: 'Stop all outbound transactions from sub-accounts.' })}</li>
          <li>{t('redirectInbound', { defaultValue: 'Redirect all inbound transactions to the parent account.' })}</li>

          <li>
            {t('moveBalances', {
              defaultValue: 'Balances in Sub-Accounts will be moved to the parent account permanently.',
            })}
          </li>
        </ul>
      </BodyText>

      <BodyText className={cn('bodyText', 'description')}>
        {t('unblockMessage', { defaultValue: 'You can unblock anytime to restore normal behaviour.' })}
      </BodyText>

      <Box className={cn('infoBox')}>
        <MaterialSymbol icon="lan" fillAmount={1} size="20px" color="#2F82FFBF" className={cn('infoIcon')} />

        <BodyText className={cn('bodyText')} size="rg">
          {t('impactMessage', { defaultValue: 'This will impact all sub-accounts.' })}
        </BodyText>
      </Box>

      <div className={cn('buttonContainer')}>
        <Button onClick={onCancel}>{t('cancelButton', { defaultValue: 'Cancel' })}</Button>

        <Button colorScheme="primary" onClick={() => onConfirm(true)}>
          {t('confirmButton', { defaultValue: 'Confirm & Block' })}
        </Button>
      </div>
    </Card>
  );
};

export default BlockDialog;
